export default function (step) {
  const fields = document.querySelector(`[data-form-step="${step}"]`).getElementsByTagName('input');
  let stepIsValid = true;

  if (!fields.length) {
    return;
  }

  [].forEach.call(fields, (function (field) {
    const error = window.validateSteps.hasError(field);

    if (error) {
      window.validateSteps.showError(field, error);
      stepIsValid = false;
    }
  }));

  return stepIsValid;
};
